<template>
  <div>
    <v-container class="page__wrapper" style="position: relative">
      <v-btn
        icon
        style="position: absolute; top: 10px; left: 10px"
        @click.native="backToRichmenu()"
      >
        <v-icon color="primary" style="font-size: 45px"
          >mdi-chevron-left</v-icon
        >
      </v-btn>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="goToPageChooseUploadImage">
          <h2 class="mt-5">
            {{ $t('Name') }} <span class="color-red">*</span>
          </h2>
          <validation-provider
            v-slot="{ errors }"
            name="Template name"
            rules="required"
          >
            <v-text-field
              v-model="templateName"
              :error-messages="errors"
              outlined
              dense
            ></v-text-field>
          </validation-provider>
          <v-row>
            <v-col>
              <div ref="setWidth" style="max-width: 230px"></div>
              <div style="text-align: -webkit-center">
                <div
                  id="template5Set"
                  style="
                    box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    -webkit-box-sizing: border-box;
                    height: 490px !important;
                  "
                  :style="{ border: `15px solid #000000 !important` }"
                >
                  <div
                    style="
                      padding-bottom: 307.556px;
                      border-top: 13px solid;
                      margin: 0px 80px;
                    "
                    :style="
                      setSize === 'lg'
                        ? `padding-bottom: ${(930 + 1686) * scaleState}px`
                        : `padding-bottom: ${(2620 + 843) * scaleState}px`
                    "
                  ></div>
                  <div :style="{ width: 2500 * scaleState }"></div>
                  <v-stage
                    ref="stage"
                    class="mt-5"
                    :config="{
                      width: 2500 * scaleState,
                      height: (setSize !== 'lg' ? 843 : 1686) * scaleState
                    }"
                    style="text-align: -webkit-center"
                  >
                    <v-layer v-if="contentToShow.length !== 0">
                      <template v-for="(area, index) in contentToShow">
                        <v-rect
                          :key="index"
                          :config="{
                            width: area.bounds.width * scaleState,
                            height: area.bounds.height * scaleState,
                            x: area.bounds.x * scaleState,
                            y: area.bounds.y * scaleState,
                            stroke: '#FFFFFF',
                            strokeWidth: 1,
                            fill: '#CCCCCC'
                          }"
                        ></v-rect>
                        <v-image
                          :key="`image___edit${index}`"
                          :config="{
                            x:
                              (area.bounds.x +
                                area.bounds.width / 2 -
                                250 / 2) *
                              scaleState,
                            y:
                              (area.bounds.y +
                                area.bounds.height / 2 -
                                250 / 2) *
                              scaleState,
                            width: 250 * scaleState,
                            height: 250 * scaleState,
                            image: editImage
                          }"
                        />
                      </template>
                    </v-layer>
                  </v-stage>
                  <div class="pl-4 keyboard">
                    <v-icon style="font-size: 28px; float: left" color="#ffffff"
                      >mdi-keyboard</v-icon
                    >
                    <div
                      class="text-center"
                      style="padding-right: 20px !important; min-height: 32px"
                    >
                      <small class="color-white"
                        >Menu
                        <v-icon color="#ffffff"> mdi-menu-down </v-icon>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <preview-template v-model="chatBarText"></preview-template> -->
            </v-col>
            <v-col>
              <template class="mb-5">
                <div class="display-block-mobile">
                  <h2 class="mt-1 mb-2">
                    {{ $t('Step') }} 1 : {{ $t('Choose Template') }}
                  </h2>
                  <v-tabs
                    v-model="mainTabs"
                    name="fade"
                    id="mainTabs"
                    class="setTabTemplate"
                    hide-slider
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      href="#mainTabs-1"
                      class="primary--text"
                      style="white-space: nowrap"
                    >
                      <span>{{ $t('custom_richmenu') }}</span>
                    </v-tab>

                    <v-tab
                      href="#mainTabs-2"
                      class="primary--text"
                      style="white-space: nowrap"
                    >
                      <span>{{ $t('preset_richmenu') }}</span>
                    </v-tab>
                  </v-tabs>
                </div>

                <v-tabs-items v-model="mainTabs" class="mb-5" mode="fade">
                  <v-tab-item
                    :value="'mainTabs-1'"
                    transition="fade-transition"
                    reverse-transition="fade-transition"
                  >
                    <template>
                      <v-tabs
                        v-model="tabs"
                        name="fade"
                        id="subTabs"
                        class="setTabTemplate"
                      >
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab href="#tabs-1" class="primary--text">
                          <span>{{ $t('Large size') }}</span>
                        </v-tab>

                        <v-tab href="#tabs-2" class="primary--text">
                          <span>{{ $t('Small size') }}</span>
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="tabs" class="mb-5" mode="fade">
                        <v-tab-item
                          :value="'tabs-1'"
                          transition="fade-transition"
                          reverse-transition="fade-transition"
                        >
                          <v-card
                            id="LargeSize"
                            class="r0 pa-10 pt-1"
                            :style="{
                              boxShadow: 'none !important'
                            }"
                          >
                            <v-row class="mt-3">
                              <!-- <transition-group name="list" tag="p"> -->
                              <template v-for="(item, index) in TemplateLarge">
                                <v-col
                                  :key="index"
                                  cols="6"
                                  xs="6"
                                  md="4"
                                  class="text-center2 list-item"
                                >
                                  <div
                                    class="bd-0 pa-1"
                                    :style="{
                                      background:
                                        templateSelect.id === item.id
                                          ? '#e6e6e6'
                                          : 'none',
                                      'border-radius': '20px 20px 0px 20px',
                                      color:
                                        templateSelect.id === item.id
                                          ? 'black'
                                          : 'inherit'
                                    }"
                                    @click="selectTemplate(item, 'lg')"
                                  >
                                    <v-img
                                      max-height="120"
                                      max-width="150"
                                      :src="item.image"
                                      :alt="item.name"
                                      :style="{
                                        filter:
                                          item.id == 0
                                            ? 'hue-rotate(110deg) grayscale(0.2) brightness(1.6)'
                                            : 'hue-rotate(100deg) grayscale(0.3) brightness(1.2)'
                                      }"
                                    ></v-img>
                                    <div v-if="item.id == 0">
                                      {{ $t('custom') }}
                                    </div>
                                    <div v-else>
                                      {{ $t('type') }} {{ item.id }}
                                    </div>
                                  </div>
                                </v-col>
                              </template>
                              <!-- </transition-group> -->
                            </v-row>
                            <template>
                              <div class="text-center mt-5">
                                <v-pagination
                                  v-model="pageLarge"
                                  :length="
                                    Math.ceil(
                                      richmenuTemplate.large.length / countPage
                                    )
                                  "
                                  circle
                                ></v-pagination>
                              </div>
                            </template>
                          </v-card>
                        </v-tab-item>
                        <!-- </template> -->

                        <!-- <template> -->
                        <v-tab-item
                          :value="'tabs-2'"
                          transition="fade-transition"
                          reverse-transition="fade-transition"
                        >
                          <v-card
                            id="SmallSize"
                            class="r0 pa-10 pt-1"
                            style="box-shadow: none !important"
                          >
                            <v-row class="mt-3">
                              <!-- <transition-group name="list" tag="p"> -->
                              <template v-for="(item, index) in TemplateSmall">
                                <v-col
                                  :key="index"
                                  cols="6"
                                  xs="6"
                                  md="4"
                                  class="text-center2 list-item"
                                >
                                  <div
                                    class="bd-0 pa-1"
                                    :style="{
                                      background:
                                        templateSelect.id === item.id
                                          ? '#e6e6e6'
                                          : 'none'
                                    }"
                                    @click="selectTemplate(item, 'sm')"
                                  >
                                    <v-img
                                      max-height="120"
                                      max-width="150"
                                      :src="item.image"
                                      :alt="item.name"
                                      :style="{
                                        filter:
                                          item.id == 100
                                            ? 'hue-rotate(110deg) grayscale(0.2) brightness(1.6)'
                                            : 'hue-rotate(100deg) grayscale(0.3) brightness(1.2)'
                                      }"
                                    ></v-img>
                                    <div v-if="item.id == 100">
                                      {{ $t('custom') }}
                                    </div>
                                    <div v-else>
                                      {{ $t('type') }} {{ item.id }}
                                    </div>
                                  </div>
                                </v-col>
                              </template>
                              <!-- </transition-group> -->
                            </v-row>
                            <template>
                              <div class="text-center mt-5">
                                <v-pagination
                                  v-model="pageSmall"
                                  :length="
                                    Math.ceil(
                                      richmenuTemplate.small.length / countPage
                                    )
                                  "
                                  circle
                                ></v-pagination>
                              </div>
                            </template>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </template>
                  </v-tab-item>
                </v-tabs-items>

                <v-tabs-items v-model="mainTabs" class="mb-5" mode="fade">
                  <v-tab-item
                    :value="'mainTabs-2'"
                    transition="fade-transition"
                    reverse-transition="fade-transition"
                  >
                    <v-card
                      id="PresetTemplate"
                      class="r0 pa-10 pt-6"
                      style="box-shadow: none !important"
                    >
                      <span class="v-middle">{{ $t('Preset Richmenu') }}</span>
                      <v-row class="mt-3">
                        <!-- <transition-group name="list" tag="p"> -->
                        <template v-for="(item, index) in presetmenu">
                          <v-col
                            :key="index"
                            cols="6"
                            xs="6"
                            md="4"
                            class="text-center2 list-item"
                          >
                            <div
                              class="bd-0 pa-1"
                              :style="{
                                background:
                                  templateSelect.id === item.id
                                    ? '#e6e6e6'
                                    : 'none',
                                'border-radius': '20px 20px 0px 20px'
                              }"
                              @click="selectPresetMenu(item)"
                            >
                              <v-img
                                style="border-radius: 20px"
                                max-height="120"
                                max-width="150"
                                :src="item.image_url"
                              ></v-img>
                              <div v-if="item.id == 0">{{ $t('custom') }}</div>
                              <div v-else>{{ $t('type') }} {{ index + 1 }}</div>
                            </div>
                          </v-col>
                        </template>
                        <!-- </transition-group> -->
                      </v-row>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </template>
            </v-col>
          </v-row>

          <template>
            <v-card class="command-bar">
              <div class="btn-sticky mt-5 pr-pl-12 sticky-left">
                <v-btn
                  outlined
                  class="btn-custom right btn-custom-outline-color"
                  :href="how_to_use_blog"
                  target="blank"
                  depressed
                  rounded
                >
                  <v-icon>mdi-help-circle</v-icon
                  ><span class="ml-1"> {{ $t('How to use') }}</span>
                </v-btn>
              </div>
              <div class="btn-sticky mt-5 pr-pl-12 sticky-right">
                <v-btn
                  outlined
                  class="btn-custom btn-next-richmenu right"
                  style="width: 180px"
                  :disabled="
                    invalid || typeof templateSelect.size === 'undefined'
                  "
                  type="submit"
                >
                  <span>
                    {{ $t('next') }}
                  </span>
                </v-btn>
              </div>
            </v-card>
          </template>
        </form>
      </validation-observer>
      <choose-upload-image
        v-if="dialog"
        v-model="dialog"
        @goToPage3="goToPage3"
      ></choose-upload-image>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChooseUploadImage from './ChooseUploadImage'
import dayjs from 'dayjs'
import icon from '../../assets/image/icons/image.png'
import configUrl from '@/config'
// import PreviewTemplate from "../../components/lineRichmenuManager/PreviewTemplate";
export default {
  computed: {
    ...mapGetters({
      richmenuTemplate: 'lineRichmenuManager/getRichmenuTemplate',
      presetmenu: 'lineRichmenuManager/getPresetmenu',
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      typeEditNew: 'lineRichmenuManager/getTypeEditNew',
      groupId: 'lineRichmenuManager/getGroupId'
    }),
    TemplateLarge() {
      return this.richmenuTemplate.large.slice(
        (this.pageLarge - 1) * this.countPage,
        this.pageLarge * this.countPage
      )
    },
    TemplateSmall() {
      return this.richmenuTemplate.small.slice(
        (this.pageSmall - 1) * this.countPage,
        this.pageSmall * this.countPage
      )
    }
  },
  components: { ChooseUploadImage },
  async mounted() {
    if (typeof this.templateSelect.name !== 'undefined') {
      this.templateName = this.templateSelect.name
    } else {
      this.templateName = `untitle${dayjs().format('DD_MM_YYYY_HH_mm')}`
    }

    await this.$nextTick()

    this.scaleState = this.$refs.setWidth
      ? this.$refs.setWidth.clientWidth / 2500
      : 1

    // this.$store.dispatch("lineRichmenuManager/setTemplateSelect", this.richmenuTemplate.large[0]);
  },
  updated() {
    try {
      this.$nextTick(() => {
        this.scaleState = this.$refs.setWidth.clientWidth / 2500
      })
    } catch (error) {
      console.error(error)
    }
  },
  async created() {
    const image = new window.Image()
    image.crossOrigin = 'Anonymous'
    image.src = icon + '?not-from-cache-please'
    image.onload = () => {
      // set image only when it is loaded
      this.editImage = image
    }
    this.$store.dispatch('lineRichmenuManager/getRichmenuTemplate')
    this.$store.dispatch('lineRichmenuManager/getPresetMenu')

    if (this.typeEditNew === 'new') {
      const path = `/${this.currentLang}/richmenu`
      if (this.$route.path !== path) {
        this.$router.push({ path })
      }
    }
  },
  data() {
    return {
      templateName: '',
      pageLarge: 1,
      pageSmall: 1,
      dialog: false,
      countPage: 6,
      mainTabs: 'mainTabs-1',
      tabs: 'tabs-1',
      chatBarText: 'Menu',
      maxWidth: 0,
      scaleState: 0,
      contentToShow: [],
      editImage: null,
      setSize: 'lg',
      how_to_use_blog: configUrl.how_to_use_blog
    }
  },
  methods: {
    backToRichmenu() {
      this.$confirm(
        `${this.$t(
          'Pressing back button may cause your previous setting will be deleted. Do you want to continue?'
        )}`,
        this.$t('Are you sure?'),
        'question',
        {
          reverseButtons: true,
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }
      ).then(async () => {
        const path = `/${this.currentLang}/richmenu`
        if (this.$route.path !== path) {
          this.$router.push({ path })
        }
      })
    },
    async selectPresetMenu(richMenu) {
      var customData = {
        name: this.templateName,
        content_json: richMenu.content_json,
        type: 'custom',
        image_url: richMenu.image_url,
        package_id: this.groupId.id || null
      }
      var res = await this.$store.dispatch(
        'lineRichmenuManager/setTemplateSelect',
        customData
      )
      if (res) {
        var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
        this.$gtag.event('event', {
          event_category: prefix + 'Step1 Custom richmenu'
          // event_label: bot.pagename + utm,
        })
        this.$emit('goToPage', 3)
      }
    },

    goToPage3() {
      this.$emit('goToPage', 3)
      this.dialog = false
    },
    async goToPageChooseUploadImage() {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      this.$gtag.event('event', {
        event_category: prefix + 'Choose Template Next'
        // event_label: bot.pagename + utm,
      })
      // console.log(this.dialog);
      if (typeof this.templateSelect.size !== 'undefined') {
        var template = {
          name: this.templateName,
          content_json: this.templateSelect,
          package_id: this.groupId.id || null
        }

        var res = await this.$store.dispatch(
          'lineRichmenuManager/setTemplateSelect',
          template
        )
        if (res) {
          this.dialog = true
          //     this.$emit("goToPage", 2);
          // console.log(this.templateSelect);
        }
      }
      //  else {
      //   this.showAlert();
      // }
    },
    selectTemplate(item, size) {
      this.setSize = size
      if (item.id === 0) {
        this.goToCustomPage('lg')
      } else if (item.id === 100) {
        this.goToCustomPage('sm')
      } else {
        var tp = JSON.stringify(item)
        this.$store.dispatch(
          'lineRichmenuManager/setTemplateSelect',
          JSON.parse(tp)
        )
        this.contentToShow = this.templateSelect.areas
        // this.goToPageChooseUploadImage();
      }
    },
    async goToCustomPage(sizeTemplate) {
      var customData = {
        name: this.templateName,
        content_json: {
          id: JSON.stringify(new Date().getTime()),
          chatBarText: this.chatBarText,
          selected: true,
          size: {
            width: 2500,
            height: sizeTemplate === 'lg' ? 1686 : 843
          },
          areas: []
        },
        type: 'custom',
        image_url: '',
        package_id: this.groupId.id || null
      }

      var res = await this.$store.dispatch(
        'lineRichmenuManager/setTemplateSelect',
        customData
      )
      if (res) {
        var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
        this.$gtag.event('event', {
          event_category: prefix + 'Step1 Custom richmenu'
          // event_label: bot.pagename + utm,
        })
        this.$emit('goToPage', 3)
      }
    }
    // showAlert() {
    //   this.$alert("Please select your template.", "Something went wrong !!", "warning").then(() =>
    //     console.log("Closed")
    //   );
    // },
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  display: inline-block;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
